module.exports = __webpack_public_path__ + "static/media/free_movie_spirit_zh.1f7627a5.png";